// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Components
import { WebpCheckbox } from "components/WebpCheckbox";

// Types
export type CheckboxLabelPosition = "label-before" | "label-after";

type WebpOptionCheckboxProps = {
    label: string;
    labelOrder: CheckboxLabelPosition;
    level: string;
    value: string;
    checked: boolean;
    layout: "switch" | "checkbox";
    onWebpCheckboxChange: (e: any) => void;
};

export const WebpOptionCheckbox: FunctionComponent<WebpOptionCheckboxProps> = ({
    label,
    labelOrder,
    level,
    value,
    checked,
    layout,
    onWebpCheckboxChange
}) => {
    return (
        <Container className={`level-${level}`}>
            <WebpCheckbox
                label={label}
                value={value}
                labelOrder={labelOrder}
                checked={checked}
                layout={layout}
                onWebpCheckboxChange={onWebpCheckboxChange}
            />
        </Container>
    );
};
